var _defs, _rect, _path, _polygon, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShakeFlask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flask",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n.cls-1 {\r\n  fill: #fff;\r\n  stroke: #000;\r\n  stroke-width: 1;}\r\n\r\n\r\n      .cls-1, .cls-2, .cls-3 {\r\n        stroke: #000;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#hachure_45_);\r\n      }\r\n\r\n      .cls-4, .cls-3 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke-width: 5px;\r\n      }\r\n.cls-1, .cls-2, .cls-3 {\r\n  stroke: #000;\r\n  stroke-width: 1;\r\n  stroke-miterlimit: 10;\r\n}\r\n\r\n    "), /*#__PURE__*/React.createElement("pattern", {
    id: "hachure_45_",
    "data-name": "hachure 45\\xB0",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    patternTransform: "translate(-7335.91 -7326.01) scale(.1)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 19.75,
    y1: 40.25,
    x2: 40.25,
    y2: 19.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: -0.25,
    y1: 40.25,
    x2: 20.25,
    y2: 19.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: -20.25,
    y1: 40.25,
    x2: 0.25,
    y2: 19.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 19.75,
    y1: 20.25,
    x2: 40.25,
    y2: -0.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: -0.25,
    y1: 20.25,
    x2: 20.25,
    y2: -0.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: -20.25,
    y1: 20.25,
    x2: 0.25,
    y2: -0.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 19.75,
    y1: 0.25,
    x2: 40.25,
    y2: -20.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: -0.25,
    y1: 0.25,
    x2: 20.25,
    y2: -20.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: -20.25,
    y1: 0.25,
    x2: 0.25,
    y2: -20.25
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.23,
    y: 8.49,
    width: 15.73,
    height: 3.43,
    rx: 1.71,
    ry: 1.71
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.82,70.93H23.38c-2.83,0-4.84-2.74-4.01-5.43l12.49-40.39c.27-.88,1.09-1.49,2.01-1.49h12.61c.93,0,1.75.61,2.02,1.49l12.32,40.4c.82,2.7-1.19,5.42-4.01,5.42Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "45.56 23.61 34.64 23.61 34.03 11.92 46.17 11.92 45.56 23.61"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 80,
    height: 80
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShakeFlask);
export default __webpack_public_path__ + "static/media/shakeFlask.f0544500fb6aff5e0ed0f343dd2ca5d8.svg";
export { ForwardRef as ReactComponent };